<script>
  import { createEventDispatcher, afterUpdate } from 'svelte';

  const dispatch = createEventDispatcher();

  export let value = '';
  export let large = false;
  export let disabled = false;

  let inputEl;
  let orgValue = '';
  let isInEditMode = false;

  const onSaveClicked = () => {
    isInEditMode = false;
    dispatch('save', value);
  };

  const onCancelClicked = () => {
    isInEditMode = false;
    value = orgValue;
  };

  const onEditClicked = () => {
    isInEditMode = true;
    orgValue = value;
  };

  afterUpdate(() => {
    if (isInEditMode && inputEl && orgValue === value) {
      inputEl.focus();
      inputEl.select();
    }
  });

  const handleKeydown = (e) => {
    if (document.activeElement === inputEl) {
      // Enter
      if (e.keyCode === 13 && value.length) {
        onSaveClicked();
      } else if (e.keyCode === 27) {
        onCancelClicked();
      }
    }
  };
</script>

<svelte:window on:keydown={handleKeydown} />

<div class="edit-input-container">
  {#if isInEditMode}
    <div class="edit-mode">
      <input {disabled} bind:value bind:this={inputEl} class:large />
      <div class="btn-container">
        <button class="icon-button" on:click={onSaveClicked}>
          <span class="material-icons"> check </span>
        </button>
        <button class="icon-button" on:click={onCancelClicked}>
          <span class="material-icons"> cancel </span>
        </button>
      </div>
    </div>
  {:else}
    <div class:disabled class="read-only" on:dblclick={onEditClicked}>
      <p class:large>{value}</p>
      <div class="btn-container">
        <button class="icon-button" on:click={onEditClicked}>
          <span class="material-icons"> edit </span>
        </button>
      </div>
    </div>
  {/if}
</div>

<style src="./editInput.scss">
</style>
